import { render, staticRenderFns } from "./configDialog.vue?vue&type=template&id=526f768c&scoped=true"
import script from "./configDialog.vue?vue&type=script&lang=js"
export * from "./configDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526f768c",
  null
  
)

export default component.exports